var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 36,
    viewBox: "0 0 11 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15871 12.3912L0.786602 13.4405L0.487599 14.8303L2.13489 15.1293C3.20632 15.3868 3.4195 15.7716 3.18694 16.8431L0.487599 29.5147C-0.218382 32.7899 0.875196 34.332 3.44165 34.332C5.43501 34.332 7.74398 33.4129 8.79326 32.1476L9.11442 30.6277C8.38629 31.27 7.31485 31.5275 6.60887 31.5275C5.60389 31.5275 5.24121 30.8215 5.49591 29.5784L9.15871 12.3912ZM9.41065 4.76387C9.41065 5.7331 9.02562 6.66263 8.34027 7.34798C7.65492 8.03333 6.72539 8.41836 5.75616 8.41836C4.78693 8.41836 3.85739 8.03333 3.17204 7.34798C2.48669 6.66263 2.10167 5.7331 2.10167 4.76387C2.10167 3.79464 2.48669 2.8651 3.17204 2.17975C3.85739 1.4944 4.78693 1.10938 5.75616 1.10938C6.72539 1.10938 7.65492 1.4944 8.34027 2.17975C9.02562 2.8651 9.41065 3.79464 9.41065 4.76387Z",
    fill: "#A90836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c77a623579e2e2f93b0f312c844019c3.svg";
export { ForwardRef as ReactComponent };